import React, { forwardRef } from "react";
import "./Radio.css";

interface RadioProps extends React.ComponentPropsWithoutRef<"input"> {
  label?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ className = "", id, label, ...otherProps }, ref) => {
    return (
      <div className={`sr-radio ${className}`}>
        <input type="radio" ref={ref} id={id || label} {...otherProps} />
        <label htmlFor={id || label}>{label}</label>
      </div>
    );
  }
);

export { Radio };
export type { RadioProps };
